function i(e) {
  return e.offsetWidth > 0 && e.offsetHeight > 0;
}
function l(e) {
  const s = document.body.querySelectorAll("*"), n = [];
  for (const t of s)
    if (!t.isEqualNode(e) && i(t)) {
      const o = getComputedStyle(t, null).getPropertyValue("z-index");
      o !== null && o !== "auto" && n.push(parseInt(o));
    }
  return n;
}
export {
  l as g,
  i
};
